import type { ColumnDefinition } from "@frui.ts/dataviews";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import type CountryResponse from "entities/countryResponse";
import { observer } from "mobx-react-lite";
import React from "react";
import { translateGeneral } from "utils/localizations";
import CountriesViewModel from "viewModels/timeCharges/distributorEnums/countries/countriesViewModel";
import ListView from "views/common/list";

const CountriesView: ViewComponent<CountriesViewModel> = observer(({ vm }) => {
  const columns: ColumnDefinition<CountryResponse>[] = [
    {
      title: vm.translateAttribute("name"),
      property: "name",
    },
    {
      title: vm.translateAttribute("code"),
      property: "code",
    },
    {
      title: vm.translateAttribute("isSepaMember"),
      property: "isSepaMember",
      valueFormatter: props => translateGeneral(`boolean.${props.value ? "true" : "false"}`),
    },
  ];

  return <ListView vm={vm} columns={columns} />;
});

registerView(CountriesView, CountriesViewModel);
